import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  index = 'CheckProtectionAntiSpy',
  quiz = 'CheckProtectionAntiSpyQuiz',
  help = 'CheckProtectionAntiSpyHelp',
  security = 'CheckProtectionAntiSpySecurity',
  leaked = 'CheckProtectionAntiSpyLeaked',
  trusted = 'CheckProtectionAntiSpyTrusted',
  finish = 'CheckProtectionAntiSpyFinish',
  preparing = 'CheckProtectionAntiSpyPreparing',
  auth = 'CheckProtectionAntiSpyAuth',
  payment = 'CheckProtectionAntiSpyPayment',
}

function preloadModule(name: MODULE_ROUTE) {
  const parentRoute = routes.find((layoutRoute) =>
    layoutRoute.children?.find((route) => route.name === name),
  );

  const route = parentRoute?.children?.find((route) => route.name === name);

  if (route && 'component' in route && typeof route.component === 'function') {
    (route.component as unknown as () => void)();
  }
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/pricing/check-protection/',
    component: () => import('@/modules/check-protection/layout/LayoutPage.vue'),
    meta: {
      i18nAlias: 'pricing',
    },
    children: [
      {
        path: '',
        name: MODULE_ROUTE.index,
        component: () =>
          import('@/modules/check-protection/pages/index/PageSafeOnline.vue'),
        meta: {
          abtestGroup: 1,
        },
        beforeEnter() {
          setTimeout(() => {
            Object.values(MODULE_ROUTE)
              .filter((moduleName) => moduleName !== MODULE_ROUTE.index)
              .forEach((moduleName) =>
                preloadModule(moduleName as MODULE_ROUTE),
              );
          }, 1000);
        },
      },
      {
        path: 'help/',
        name: MODULE_ROUTE.help,
        component: () =>
          import('@/modules/check-protection/pages/help/PageSafeOnlineHelp.vue'),
      },
      {
        path: 'security/',
        name: MODULE_ROUTE.security,
        component: () =>
          import('@/modules/check-protection/pages/security/PageSafeOnlineSecurity.vue'),
      },
      {
        path: 'leaked/',
        name: MODULE_ROUTE.leaked,
        component: () =>
          import('@/modules/check-protection/pages/leaked/PageSafeOnlineLeaked.vue'),
      },
      {
        path: 'trusted/',
        name: MODULE_ROUTE.trusted,
        component: () =>
          import('@/modules/check-protection/pages/trusted/PageSafeOnlineTrusted.vue'),
      },
      {
        path: 'finish/',
        name: MODULE_ROUTE.finish,
        component: () =>
          import('@/modules/check-protection/pages/finish/PageSafeOnlineFinish.vue'),
      },
      {
        path: 'quiz/',
        name: MODULE_ROUTE.quiz,
        component: () =>
          import('@/modules/check-protection/pages/quiz/PageQuiz.vue'),
      },
      {
        path: 'preparing/',
        name: MODULE_ROUTE.preparing,
        component: () =>
          import('@/modules/check-protection/pages/preparing/PagePreparing.vue'),
      },
      {
        path: 'auth/',
        name: MODULE_ROUTE.auth,
        component: () =>
          import('@/modules/check-protection/pages/auth/PageAuth.vue'),
      },
      {
        path: 'payment/',
        name: MODULE_ROUTE.payment,
        component: () =>
          import('@/modules/check-protection/pages/payment/PagePayment.vue'),
        meta: {
          i18nAlias: 'pricing',
        },
      },
    ],
  },
];
